
import * as React from 'react';
import { connect } from 'react-redux';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { RequestApiResult } from 'loopback-react-request';
import { GlobalPrivateState } from 'src/api';
import { Button, Label, Input } from 'reactstrap';
import { Redirect } from 'react-router';
import { RouterState } from 'connected-react-router';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ProjectWithout.messages';

export interface ProjectWithoutProps {
  configuration: RequestApiResult<ConfigurationModel>;
  location: RouterState['location'];
}

export interface ProjectWithoutState {
  checked: boolean;
  redirect: boolean;
}

export class ProjectWithoutPartial extends React.Component<ProjectWithoutProps, ProjectWithoutState> {

  constructor(props: ProjectWithoutProps) {
    super(props);
    this.state = {
      checked: false,
      redirect: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  public render() {
    const redirectUrl = this.configurationId && `/configuration/${this.configurationId}/trough`;
    const currentUrl = this.props.location.pathname;
    return (
      <div className="partial-project-select">
        <div className="row m-0 mb-3">
          <div className="col-12 text-center">
            <Label>
              <FormattedMessage {...MESSAGES.projectWithoutLabel} />
              <Input
                type="checkbox"
                id="continueWithoutProject"
                className="text-center"
                onChange={this.handleChange}
              />
              <span className="checkmark" />
            </Label>
          </div>
        </div>
        <div className="row m-0">
          <div className="col-12 text-center">
            <Button
              className="register-button mt-3"
              type="submit"
              onClick={this.handleClick}
              disabled={!this.state.checked}
            >
              <FormattedMessage {...MESSAGES.projectWithoutLabelButton} />
            </Button>
          </div>
        </div>
        {this.state.redirect && redirectUrl && redirectUrl !== currentUrl && (
          <Redirect to={redirectUrl} />
        )}
      </div>
    );
  }

  private get configurationId(): string | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result && configuration.result.id;
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement;
    this.setState({
      checked: target.checked,
    });
  }

  private handleClick(event: React.SyntheticEvent<HTMLButtonElement>) {
    if (this.state.checked) {
      this.setState({
        redirect: true,
      });
    }
  }
}

export const ProjectWithout = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  location: state.router.location,
}))(ProjectWithoutPartial);

export default ProjectWithout;